/* ===== AROMAZUR — valeur reelle des packs =================================
   Un pack contient un diffuseur et trois flacons de 20 ml. Le client ne voit
   qu'un prix global : rien ne lui dit que les trois flacons lui seraient
   factures beaucoup plus cher achetes separement.

   REGLE ABSOLUE : le montant affiche est CALCULE a partir des prix reels
   Shopify du moment (window.AZ_PRICE sur l'accueil, /products/xxx.js
   ailleurs), jamais ecrit en dur. Pendant une promotion, les deux cotes de
   la comparaison baissent ensemble et l'ecart se recalcule tout seul. Un
   montant fige deviendrait faux des le lendemain d'un changement de prix,
   et une comparaison fausse est une pratique commerciale trompeuse au sens
   de l'article L121-2 du code de la consommation.

   Si un seul des prix necessaires manque, on n'affiche AUCUN montant :
   on se rabat sur la mention neutre « 3 huiles de 20 ml incluses ».
   ========================================================================= */
(function(){
  'use strict';

  /* Correspondance pack -> diffuseur contenu. Handles Shopify reels,
     sans le prefixe « az- » de la base statique du theme.                 */
  var PACKS = {
    'pack-decouverte-mini-diffuseur':
      { diff:'mini-diffuseur-d-huiles-parfumees', n:3, fmt:'20 ml' },
    'pack-decouverte-diffuseur-de-parfum':
      { diff:'diffuseur-de-parfum', n:3, fmt:'20 ml' },
    'pack-decouverte-diffuseur-de-parfum-sans-fil-huiles-parfumees':
      { diff:'diffuseur-de-parfum-sans-fil-huiles-parfumees', n:3, fmt:'20 ml' },
    'pack-decouverte-diffuseur-de-parfum-enceinte-prenium-aromasound™':
      { diff:'diffuseur-de-parfum-enceinte-prenium', n:3, fmt:'20 ml' }
  };

  /* Seuil en dessous duquel on ne met pas de montant en avant : annoncer
     « 2 € d'economie » dessert le produit plus qu'il ne le sert.          */
  var SEUIL = 5;

  function eur(v){
    return v.toFixed(2).replace('.', ',') + ' €';
  }

  function minPrix(obj){
    if(!obj) return null;
    var k = Object.keys(obj), m = null, i, v;
    for(i=0;i<k.length;i++){
      v = obj[k[i]];
      if(typeof v === 'number' && v > 0 && (m === null || v < m)) m = v;
    }
    return m;
  }

  /* Prix du 20 ml : injecte par theme.liquid depuis la collection huiles. */
  function prixHuile20(){
    var O = window.AZ_OIL_PRICES;
    if(!O) return null;
    var k = Object.keys(O), i;
    for(i=0;i<k.length;i++){
      if(k[i].replace(/\s/g,'').toLowerCase() === '20ml' && typeof O[k[i]] === 'number')
        return O[k[i]];
    }
    return null;
  }

  function prixCarte(h){
    var P = window.AZ_PRICE;
    return (P && P[h]) ? minPrix(P[h]) : null;
  }

  /* Filet quand AZ_PRICE n'existe pas (pages autres que l'accueil).       */
  var cache = {};
  function prixDistant(h){
    if(cache[h] !== undefined) return cache[h];
    var cle = 'azpv:' + h, mem = null;
    try{ mem = sessionStorage.getItem(cle); }catch(e){}
    if(mem !== null){
      cache[h] = (mem === '' ? null : parseFloat(mem));
      return cache[h];
    }
    if(typeof fetch !== 'function') return null;
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var v = null, i;
        if(j && j.variants){
          for(i=0;i<j.variants.length;i++){
            var p = j.variants[i].price;
            if(typeof p === 'number'){ p = p/100; if(v === null || p < v) v = p; }
          }
        }
        try{ sessionStorage.setItem(cle, v === null ? '' : String(v)); }catch(e){}
        return v;
      })
      .catch(function(){ return null; });
    return cache[h];
  }

  /* Renvoie une promesse resolue avec {eco, n} ou null.                    */
  function calcul(handle){
    var cfg = PACKS[handle];
    if(!cfg) return Promise.resolve(null);

    var pH = prixHuile20();
    var pPack = prixCarte(handle);
    var pDiff = prixCarte(cfg.diff);

    var attente = [
      pPack !== null ? pPack : prixDistant(handle),
      pDiff !== null ? pDiff : prixDistant(cfg.diff)
    ];

    return Promise.all(attente).then(function(r){
      var a = r[0], b = r[1];
      if(typeof a !== 'number' || typeof b !== 'number' || typeof pH !== 'number')
        return { eco:null, n:cfg.n };
      var eco = Math.round((b + cfg.n * pH - a) * 100) / 100;
      return { eco: (eco >= SEUIL ? eco : null), n:cfg.n };
    }).catch(function(){ return { eco:null, n:cfg.n }; });
  }

  function texte(res){
    if(!res) return '';
    if(res.eco === null)
      return res.n + ' huiles de 20 ml incluses, au choix';
    return res.n + ' huiles de 20 ml incluses — <b>' + eur(res.eco) +
           ' d’économie</b> sur l’achat séparé';
  }

  function style(){
    if(document.getElementById('azPvStyle')) return;
    var s = document.createElement('style');
    s.id = 'azPvStyle';
    s.textContent =
      '.az-pv{display:block;margin:6px 0 2px;font-size:13px;line-height:1.35;' +
      'color:#8A6D1F;letter-spacing:.01em}' +
      '.az-pv b{color:#B8901F;font-weight:600}' +
      '.pp-pv{display:block;margin:10px 0 0;font-size:15px;line-height:1.4;' +
      'padding:10px 14px;border-left:3px solid #D4AF37;background:#FCF8EE;' +
      'color:#6E5714;border-radius:0 6px 6px 0}' +
      '.pp-pv b{color:#8A6D1F;font-weight:700}';
    document.head.appendChild(s);
  }

  /* Nettoie un href de carte pour en extraire le handle.                   */
  function handleDe(href){
    if(!href) return null;
    var m = String(href).split('?')[0].split('#')[0].match(/\/products\/([^\/]+)$/);
    if(!m) return null;
    try{ return decodeURIComponent(m[1]); }catch(e){ return m[1]; }
  }

  function cartes(){
    var liens = document.querySelectorAll('a[href*="/products/pack-decouverte"]'), i;
    var vus = {};
    for(i=0;i<liens.length;i++){
      (function(a){
        var h = handleDe(a.getAttribute('href'));
        if(!h || !PACKS[h]) return;
        var corps = a.closest ? a.closest('.card-body') : null;
        if(!corps) return;
        if(corps.querySelector('.az-pv')) return;
        var titre = corps.querySelector('h3');
        if(!titre) return;
        var cle = h + '|' + (vus[h] = (vus[h]||0) + 1);
        var span = document.createElement('span');
        span.className = 'az-pv';
        span.setAttribute('data-az-pv', cle);
        titre.parentNode.insertBefore(span, titre.nextSibling);
        calcul(h).then(function(res){
          var t = texte(res);
          if(t) span.innerHTML = t; else span.parentNode.removeChild(span);
        });
      })(liens[i]);
    }
  }

  function fiche(){
    var h = handleDe(location.pathname);
    if(!h || !PACKS[h]) return;
    var prix = document.getElementById('ppPrice');
    if(!prix || document.querySelector('.pp-pv')) return;
    var p = document.createElement('p');
    p.className = 'pp-pv';
    prix.parentNode.insertBefore(p, prix.nextSibling);
    calcul(h).then(function(res){
      var t = texte(res);
      if(t) p.innerHTML = t; else p.parentNode.removeChild(p);
    });
  }

  function go(){
    if(typeof Promise !== 'function') return;
    style();
    cartes();
    fiche();
  }

  if(document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', go);
  else go();

  /* Les cartes de l'accueil sont parfois reconstruites apres coup
     (filtres, synchronisation des prix) : on repasse une fois.            */
  setTimeout(function(){ if(document.body) cartes(); }, 1200);
})();
